<div class="final-review"
     data-testid="discuss-demonstrate-final-review">
  <schedule-detail-header [title]="headerTitle()"
                          [subtitle]="subtitle()"
                          [backCallback]="goBack.bind(this)"
                          [showCloud]="true"
                          [bottomBorder]="true"></schedule-detail-header>
  @if (!dataLoaded()) {
    <div class="skeleton-issues"
         data-testid="discuss-demonstrate-final-review-skeleton">
      <p-skeleton height="1rem"
                  width="5rem"></p-skeleton>
      <p-skeleton height="2rem"
                  width="10rem"></p-skeleton>
      <p-skeleton height="15rem"></p-skeleton>
    </div>
  } @else {
    <div class="step-container"
         data-testid="discuss-demonstrate-final-review-steps">
      <div id="step-text"
           class="step-text"
           data-testid="discuss-demonstrate-text-step-indicator">
        STEP {{step()}} OF 3
      </div>
      @switch (step()) {
        @case (1) {
          <div class="step-header-container">
            <h1 class="header-lg-bold step-header">Review Follow-up</h1>
            @if (openIssues().length > 0) {
              <div class="body-md-regular step-description">
                Here are the {{openIssues().length}} follow-up items identified during today's walkthrough.
              </div>
            }
          </div>
          <div class="step-content">
            <app-punchlist [dataLoaded]="dataLoaded()"
                           [areaNames]="areaNames()"
                           [issuesByArea]="issuesByArea()"
                           [imagesOfIssue]="imagesOfIssue()"
                           [vendorOfIssue]="vendorOfIssue()"
                           [disableEditing]="true"
                           (viewImage)="openImagesModal($event.issueId, $event.imageIndex)">
            </app-punchlist>
          </div>
        }
        @case (2) {
          <div class="step-header-container">
            <h1 class="header-lg-bold step-header">Review Home Items</h1>
            <div class="body-md-regular step-description">
              These are the features and systems reviewed with the homeowner today.
            </div>
          </div>
          <div class="step-content">
            <app-checklist [checklistGroups]="checklistGroups()"
                           [readonly]="true" />
          </div>
        }
        @case (3) {
          <div class="step-header-container">
            <h1 class="header-lg-bold step-header">Confirm & Sign</h1>
            <div class="body-md-regular step-description">
              You've reached the final step of your walkthrough. Confirm and sign to complete your Final Review.
            </div>
          </div>
          <div class="step-content">
            <form [formGroup]="homeownerSignatures">
              <div class="form-container">
                <div>
                  <div class="checkbox-container">
                    <p-checkbox name="checklistConfirmation"
                                formControlName="checklistConfirmation"
                                inputId="confirmation-checkbox"
                                binary
                                data-testid="discuss-demonstrate-toggle-checklist-confirmation" />
                    <label for="confirmation-checkbox">
                      I confirm these items were reviewed with the homeowner today.
                    </label>
                  </div>
                  @if (isInvalid('checklistConfirmation')) {
                    <p-message severity="error"
                               size="small"
                               variant="simple">
                      Please confirm these items were reviewed before finishing your Final Review.
                    </p-message>
                  }
                </div>
                <div class="signature-container">
                  <div class="body-sm-bold">Homeowner 1</div>
                  <div class="signature-inputs">
                    <input class="body-md-regular signature-input"
                           name="homeowner1Name"
                           formControlName="homeowner1Name"
                           placeholder="Full Name"
                           aria-label="Homeowner 1 Name"
                           data-testid="discuss-demonstrate-input-homeowner1-name" />
                    @if (isInvalid('homeowner1Name')) {
                      <p-message severity="error"
                                 size="small"
                                 variant="simple">Please enter your full name to sign.</p-message>
                    }
                    <input class="body-md-regular signature-input"
                           name="homeowner1Email"
                           formControlName="homeowner1Email"
                           placeholder="Email Address"
                           aria-label="Homeowner 1 Email Address"
                           data-testid="discuss-demonstrate-input-homeowner1-email" />
                    @if (isInvalid('homeowner1Email')) {
                      @if (homeownerSignatures.get('homeowner1Email')?.errors?.['required']) {
                        <p-message severity="error"
                                   size="small"
                                   variant="simple">Please enter your email to sign.</p-message>
                      }
                      @if (homeownerSignatures.get('homeowner1Email')?.errors?.['email']) {
                        <p-message severity="error"
                                   size="small"
                                   variant="simple">Please enter a valid email.</p-message>
                      }
                    }
                  </div>
                </div>
                <div class="signature-container">
                  <div class="body-sm-bold">Homeowner 2</div>
                  <div class="signature-inputs">
                    <input class="body-md-regular signature-input"
                           name="homeowner2Name"
                           formControlName="homeowner2Name"
                           placeholder="Full Name"
                           aria-label="Homeowner 2 Name"
                           data-testid="discuss-demonstrate-input-homeowner2-name" />
                    @if (isHomeowner2NameInvalid()) {
                      <p-message severity="error"
                                 size="small"
                                 variant="simple">Please enter Homeowner 2's full name.</p-message>
                    }
                    <input class="body-md-regular signature-input"
                           name="homeowner2Email"
                           formControlName="homeowner2Email"
                           placeholder="Email Address"
                           aria-label="Homeowner 2 Email Address"
                           data-testid="discuss-demonstrate-input-homeowner2-email" />
                    @if (isHomeowner2EmailInvalid()) {
                      @if (homeownerSignatures.errors?.['homeowner2EmailRequired']) {
                        <p-message severity="error"
                                   size="small"
                                   variant="simple">Please enter Homeowner 2's email address.</p-message>
                      }
                      @if (homeownerSignatures.get('homeowner2Email')?.errors?.['email']) {
                        <p-message severity="error"
                                   size="small"
                                   variant="simple">Please enter a valid email.</p-message>
                      }
                    }
                  </div>
                </div>
              </div>
            </form>
          </div>
        }
      }
    </div>
    <div class="discuss-demonstrate-final-review-footer"
         data-testid="discuss-demonstrate-final-review-footer">
      @if (step() !== 1) {
        <button (click)="previousStep()"
                class="button"
                data-testid="discuss-demonstrate-btn-previous-step">
          Summary
        </button>
      }
      <button (click)="nextStep()"
              class="button next"
              data-testid="discuss-demonstrate-btn-next-step">
        @switch (step()) {
          @case (1) { Go to Step 2 }
          @case (2) { Go to Final Step }
          @case (3) { Finish }
        }
      </button>
    </div>
  }
</div>